module.exports = __webpack_public_path__ + "static/media/TasklyPreview@2x.dea1c296.png";